import { MessageCircle, ScanLine, Video } from "lucide-react";
import { LIVE_STEPS } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";
import LiveSessionCard from "@/components/home/LiveSessionCard";

const ICONS = [ScanLine, Video, MessageCircle];

export default function LiveExperience() {
  return (
    <section
      data-testid="live-experience"
      className="relative overflow-hidden border-t border-white/10 bg-ink px-6 py-28 text-bone sm:px-10 sm:py-36 lg:px-16"
    >
      <div
        aria-hidden="true"
        className="absolute -right-40 top-0 h-[30rem] w-[30rem] rounded-full bg-limed opacity-[0.1] blur-[140px]"
      />
      <div className="relative mx-auto max-w-[1440px]">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-24">
          <div>
            <FadeIn>
              <Eyebrow>The Live Coaching Experience</Eyebrow>
            </FadeIn>
            <FadeIn delay={0.1}>
              <h2 className="mt-8 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
                No app. No guesswork. <span className="text-lime">A coach on camera.</span>
              </h2>
            </FadeIn>
            <FadeIn delay={0.15}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-ash sm:text-lg">
                Every session is a private, live video consultation — real-time technique adjustment,
                hands-on cueing and personal accountability.
              </p>
            </FadeIn>
            <FadeIn delay={0.2} className="mt-10 flex flex-wrap items-center gap-3">
              {["Zoom", "Google Meet", "WhatsApp"].map((t) => (
                <span
                  key={t}
                  className="border border-lime/30 bg-lime/10 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] text-lime"
                >
                  {t}
                </span>
              ))}
            </FadeIn>
          </div>
          <FadeIn delay={0.15}>
            <LiveSessionCard />
          </FadeIn>
        </div>

        <div className="mt-24">
          {LIVE_STEPS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <FadeIn key={s.n} delay={i * 0.08}>
                <div
                  data-testid={`live-step-${s.n}`}
                  className="group grid gap-6 border-t border-white/10 py-12 last:border-b sm:grid-cols-[140px_1fr_1.1fr] sm:items-start sm:gap-10"
                >
                  <div className="flex items-center gap-5">
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-lime">{s.n}</p>
                    <Icon className="h-6 w-6 text-ash transition-colors duration-300 group-hover:text-lime" />
                  </div>
                  <div>
                    <h3 className="font-display text-3xl font-black uppercase tracking-tight text-white sm:text-4xl">
                      {s.title}
                    </h3>
                    <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-ash">
                      {s.detail}
                    </p>
                  </div>
                  <p className="max-w-lg text-base leading-relaxed text-ash">{s.copy}</p>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
}
